/*
* Broadcast Theme - custom.js (vanilla)
*/

/**
 * Event Delegation helper:
 * runs handler when event target (or its parent) matches selector
 */
function on(delegateTarget, eventName, selector, handler) {
  delegateTarget.addEventListener(eventName, (event) => {
    const target = event.target.closest(selector);
    if (!target) return;
    handler(event, target);
  });
}

/**
 * Helper: find nearest parent and then a child inside it
 */
function toggleHasLineItem(clickedEl, add) {
  const wrappers = [
    clickedEl.closest(".form__wrapper"),
    clickedEl.closest(".product-quick-add__form"),
  ].filter(Boolean);

  wrappers.forEach((wrap) => {
    const btn = wrap.querySelector(".btn--primary");
    if (!btn) return;
    btn.classList.toggle("hasLineItem", add);
  });
}

/**
 * Build inactive product galleries only when a customer selects them.
 * Content inside <template> is inert, so its images and swiper instances do
 * not compete with the active product image during the initial page load.
 */
function hydrateVariantGallery(gallery) {
  if (!gallery) return;
  const template = gallery.querySelector(':scope > template[data-variant-gallery-template]');
  if (!template) return;
  template.replaceWith(template.content.cloneNode(true));
  gallery.removeAttribute('data-deferred-variant-gallery');
}

/**
 * 1) Click on select popout option
 */
on(document, "click", ".select-popout__item .select-popout__option", (event, el) => {
  const isFirst = el.classList.contains("first-opt");
  toggleHasLineItem(el, isFirst);

  const popout = el.closest("popout-select");
  const toggle = popout && popout.querySelector("[data-popout-toggle]");
  if (toggle) toggle.setAttribute("aria-invalid", isFirst ? "true" : "false");
});

/**
 * Required line-item dropdowns use their first option as a placeholder.
 * Keep the add-to-cart button clickable, but open the incomplete dropdown
 * instead of submitting the product form.
 */
function findIncompleteRequiredLineItem(form) {
  return Array.from(document.querySelectorAll("input[data-popout-input]")).find((input) => {
    if (input.form !== form) return false;

    const popout = input.closest("popout-select");
    const firstOption = popout && popout.querySelector(".select-popout__option.first-opt");
    return firstOption && input.value === firstOption.getAttribute("data-value");
  });
}

function openIncompleteRequiredLineItem(event, form) {
  const incompleteInput = findIncompleteRequiredLineItem(form);
  if (!incompleteInput) return false;

  event.preventDefault();
  event.stopImmediatePropagation();

  const popout = incompleteInput.closest("popout-select");
  const toggle = popout && popout.querySelector("[data-popout-toggle]");
  if (!toggle) return true;

  toggle.setAttribute("aria-invalid", "true");
  toggle.focus();

  if (toggle.getAttribute("aria-expanded") !== "true") {
    toggle.click();
  }

  return true;
}

document.addEventListener("click", (event) => {
  const button = event.target.closest && event.target.closest("[data-add-to-cart]");
  if (!button) return;

  const form = button.form || button.closest("form[data-product-form]");
  if (!form || !form.hasAttribute("data-product-form")) return;

  openIncompleteRequiredLineItem(event, form);
}, true);

document.addEventListener("submit", (event) => {
  const form = event.target.closest && event.target.closest("form[data-product-form]");
  if (!form) return;

  openIncompleteRequiredLineItem(event, form);
}, true);

/**
 * 2) Change on variant radio buttons (product page)
 * Switch active images based on selected variant id input
 */
on(document, "change", ".product__page .radio__button input", () => {
  const productPage = document.querySelector(".product__page");
  if (!productPage) return;

  // In Broadcast, the selected variant id is usually in input[name="id"]
  const idInput = productPage.querySelector('input[name="id"]');
  if (!idInput) return;

  // Let theme scripts update the hidden variant id first
  setTimeout(() => {
    const val = idInput.value;

    document.querySelectorAll(".custom-variant-images").forEach((n) => n.classList.remove("active"));

    const match = document.querySelector(`.custom-variant-images[data-id="${CSS.escape(val)}"]`);
    const all = document.querySelector(".custom-all-images");

    if (match) {
      hydrateVariantGallery(match);
      if (all) all.classList.remove("active");
      match.classList.add("active");
    } else {
      if (all) {
        hydrateVariantGallery(all);
        all.classList.add("active");
      }
    }
  }, 100);
});

/**
 * 3) Click on a.addsingleproduct -> redirect to data-url
 */
on(document, "click", "a.addsingleproduct", (event, el) => {
  event.preventDefault();
  const redirectUrl = el.getAttribute("data-url");
  if (redirectUrl) window.location.href = redirectUrl;
});

/**
 * 4) Make .column__inner clickable if it contains a link
 */
document.querySelectorAll(".column__inner").forEach((el) => {
  const link = el.querySelector("a");
  if (!link) return;

  el.style.cursor = "pointer";
  el.addEventListener("click", (e) => {
    // prevent double navigation if user clicked the actual link
    if (e.target.closest("a")) return;
    window.location.href = link.href;
  });
});

/* Search intent filters: keep multi-word jewellery searches precise. */
(() => {
  const formSelector = 'form.search-form';
  const injectedAttribute = 'data-search-intent-filter';
  const displayTermParameter = 'display_q';

  const normalizeSearchTerm = (value) =>
    value
      .toLocaleLowerCase('de')
      .normalize('NFD')
      .replace(/[\u0300-\u036f]/g, '')
      .replace(/ß/g, 'ss')
      .replace(/[^a-z0-9]+/g, ' ')
      .trim();

  const includesTerm = (term, values) =>
    values.some((value) => term === value || term.startsWith(`${value} `) || term.endsWith(` ${value}`) || term.includes(` ${value} `));

  const removeRecognizedTerms = (term, values) =>
    [...new Set(values)]
      .sort((first, second) => second.length - first.length)
      .reduce(
        (remaining, value) =>
          ` ${remaining} `.replaceAll(` ${value} `, ' ').replace(/\s+/g, ' ').trim(),
        term
      );

  const appendFilter = (form, name, value) => {
    const input = document.createElement('input');
    input.type = 'hidden';
    input.name = name;
    input.value = value;
    input.setAttribute(injectedAttribute, '');
    form.appendChild(input);
  };

  const applySearchIntentFilters = (form) => {
    form.querySelectorAll(`[${injectedAttribute}]`).forEach((input) => input.remove());

    const searchInput = form.querySelector('input[name="q"]');
    const originalTerm = searchInput ? searchInput.value.trim() : '';
    const term = normalizeSearchTerm(originalTerm);
    if (!term) return;

    const recognizedTerms = [];
    let productTypes = [];
    if (includesTerm(term, ['ohrring kette', 'ohrring ketten', 'ohrringkette', 'ohrringketten', 'ohr kette', 'ohr ketten', 'ohrkette', 'ohrketten', 'piercing kette', 'piercing ketten', 'piercingkette', 'piercingketten', 'ear chain', 'ear chains', 'earring chain', 'earring chains'])) {
      productTypes = ['Ohrring Ketten'];
      recognizedTerms.push('ohrring kette', 'ohrring ketten', 'ohrringkette', 'ohrringketten', 'ohr kette', 'ohr ketten', 'ohrkette', 'ohrketten', 'piercing kette', 'piercing ketten', 'piercingkette', 'piercingketten', 'ear chain', 'ear chains', 'earring chain', 'earring chains');
    } else if (includesTerm(term, ['halskette', 'halsketten', 'necklace', 'necklaces'])) {
      productTypes = ['Halsketten'];
      recognizedTerms.push('halskette', 'halsketten', 'necklace', 'necklaces');
    } else if (includesTerm(term, ['kette', 'ketten', 'chain', 'chains'])) {
      productTypes = ['Halsketten', 'Ohrring Ketten'];
      recognizedTerms.push('kette', 'ketten', 'chain', 'chains');
    } else if (includesTerm(term, ['creole', 'creolen', 'hoop earring', 'hoop earrings', 'hoop', 'hoops', 'huggie earring', 'huggie earrings', 'huggie', 'huggies'])) {
      productTypes = ['Creolen'];
      recognizedTerms.push('creole', 'creolen', 'hoop earring', 'hoop earrings', 'hoop', 'hoops', 'huggie earring', 'huggie earrings', 'huggie', 'huggies');
    } else if (includesTerm(term, ['ohrstecker', 'stecker', 'stud earring', 'stud earrings', 'ear stud', 'ear studs', 'earring stud', 'earring studs', 'stud', 'studs'])) {
      productTypes = ['Ohrstecker'];
      recognizedTerms.push('ohrstecker', 'stecker', 'stud earring', 'stud earrings', 'ear stud', 'ear studs', 'earring stud', 'earring studs', 'stud', 'studs');
    } else if (includesTerm(term, ['clicker ring', 'clicker rings', 'clicker', 'clickers'])) {
      productTypes = ['Clicker'];
      recognizedTerms.push('clicker ring', 'clicker rings', 'clicker', 'clickers');
    } else if (includesTerm(term, ['ohrring anhanger', 'ohrring anhaenger', 'earring charm', 'earring charms', 'ear charm', 'ear charms', 'anhanger', 'anhaenger', 'charm', 'charms'])) {
      productTypes = ['Ohrring Anhänger'];
      recognizedTerms.push('ohrring anhanger', 'ohrring anhaenger', 'earring charm', 'earring charms', 'ear charm', 'ear charms', 'anhanger', 'anhaenger', 'charm', 'charms');
    } else if (includesTerm(term, ['armband', 'armbander', 'bracelet', 'bracelets'])) {
      productTypes = ['Armbänder'];
      recognizedTerms.push('armband', 'armbander', 'bracelet', 'bracelets');
    } else if (includesTerm(term, ['earring', 'earrings'])) {
      productTypes = ['Creolen', 'Ohrstecker', 'Clicker'];
      recognizedTerms.push('earring', 'earrings');
    }

    const isEnglish = document.documentElement.lang
      .toLowerCase()
      .startsWith('en');

    let material = '';
    if (includesTerm(term, ['weissgold', 'white gold'])) {
      material = isEnglish ? '14k White Gold' : '585 Weißgold';
      recognizedTerms.push('weissgold', 'white gold');
    } else if (includesTerm(term, ['gelbgold', 'yellow gold', 'gold'])) {
      material = isEnglish ? '14k Yellow Gold' : '585 Gelbgold';
      recognizedTerms.push('gelbgold', 'yellow gold', 'gold');
    }

    let piercingPosition = '';
    if (includesTerm(term, ['high lobe', 'highlobe', 'upper lobe', 'upperlobe'])) {
      piercingPosition = 'High Lobe';
      recognizedTerms.push('high lobe', 'highlobe', 'upper lobe', 'upperlobe');
    } else if (includesTerm(term, ['helix'])) {
      piercingPosition = 'Helix';
      recognizedTerms.push('helix');
    } else if (includesTerm(term, ['conch'])) {
      piercingPosition = 'Conch';
      recognizedTerms.push('conch');
    } else if (includesTerm(term, ['tragus'])) {
      piercingPosition = 'Tragus';
      recognizedTerms.push('tragus');
    } else if (includesTerm(term, ['daith'])) {
      piercingPosition = 'Daith';
      recognizedTerms.push('daith');
    } else if (includesTerm(term, ['rook'])) {
      piercingPosition = 'Rook';
      recognizedTerms.push('rook');
    } else if (includesTerm(term, ['industrial'])) {
      piercingPosition = 'Industrial';
      recognizedTerms.push('industrial');
    } else if (includesTerm(term, ['flat', 'scapha'])) {
      piercingPosition = 'Flat';
      recognizedTerms.push('flat', 'scapha');
    } else if (includesTerm(term, ['ear lobe', 'earlobe', 'lobe'])) {
      piercingPosition = 'Lobe';
      recognizedTerms.push('ear lobe', 'earlobe', 'lobe');
    }

    if (piercingPosition) recognizedTerms.push('piercing');

    if (material && includesTerm(term, ['14k', '14 karat', '585'])) {
      recognizedTerms.push('14k', '14 karat', '585');
    }

    const isPiercingRing =
      piercingPosition &&
      includesTerm(term, ['ring', 'piercing ring', 'piercingring']);

    if (isPiercingRing) {
      productTypes = piercingPosition === 'Daith' ? [] : ['Clicker', 'Creolen'];
      recognizedTerms.push('ring', 'piercing ring', 'piercingring');
    }

    if (searchInput && (productTypes.length || material || piercingPosition)) {
      searchInput.value = removeRecognizedTerms(term, recognizedTerms) || '*';
      appendFilter(form, displayTermParameter, originalTerm);
    }

    productTypes.forEach((productType) =>
      appendFilter(form, 'filter.p.product_type', productType)
    );
    if (material) appendFilter(form, 'filter.p.m.theme.siblings_color', material);
    if (piercingPosition) appendFilter(form, 'filter.p.m.custom.piercingposition', piercingPosition);
  };

  document.addEventListener(
    'submit',
    (event) => {
      const form = event.target;
      if (form instanceof HTMLFormElement && form.matches(formSelector)) {
        applySearchIntentFilters(form);
        observeSearchDisplayUpdates();
      }
    },
    true
  );

  const restoreSearchDisplayTerm = () => {
    const params = new URLSearchParams(window.location.search);
    const displayTerm = params.get(displayTermParameter);
    const searchTerm = params.get('q');

    if (!displayTerm || !searchTerm) return;

    document
      .querySelectorAll(`${formSelector} input[name="q"]`)
      .forEach((input) => {
        input.value = displayTerm;
      });

    const replaceSearchTerm = (value) => {
      if (!value) return value;

      return value
        .replaceAll(`"${searchTerm}"`, `"${displayTerm}"`)
        .replaceAll(`„${searchTerm}“`, `„${displayTerm}“`)
        .replaceAll(`“${searchTerm}”`, `“${displayTerm}”`);
    };

    document.querySelectorAll('[data-results-count]').forEach((element) => {
      const nextText = replaceSearchTerm(element.textContent);
      if (nextText !== element.textContent) element.textContent = nextText;
    });

    const nextTitle = replaceSearchTerm(document.title);
    if (nextTitle !== document.title) document.title = nextTitle;

    document.querySelectorAll('a[href]').forEach((link) => {
      const url = new URL(link.href, window.location.origin);
      const isSearchLink =
        url.origin === window.location.origin &&
        url.pathname.endsWith('/search') &&
        url.searchParams.has('q');

      if (!isSearchLink || url.searchParams.has(displayTermParameter)) return;

      url.searchParams.set(displayTermParameter, displayTerm);
      link.href = `${url.pathname}${url.search}${url.hash}`;
    });

    document.querySelectorAll('form[action]').forEach((form) => {
      const action = new URL(form.action, window.location.origin);
      const isSearchForm =
        action.origin === window.location.origin &&
        action.pathname.endsWith('/search');

      if (!isSearchForm || form.querySelector(`input[name="${displayTermParameter}"]`)) return;
      appendFilter(form, displayTermParameter, displayTerm);
    });
  };

  let searchDisplayObserver;
  let searchDisplayObserverTimer;
  let searchDisplayUpdateScheduled = false;

  const scheduleSearchDisplayRestore = () => {
    if (searchDisplayUpdateScheduled) return;
    searchDisplayUpdateScheduled = true;

    window.requestAnimationFrame(() => {
      searchDisplayUpdateScheduled = false;
      restoreSearchDisplayTerm();
    });
  };

  const observeSearchDisplayUpdates = () => {
    if (!document.body.classList.contains('template-search')) return;

    if (searchDisplayObserver) searchDisplayObserver.disconnect();
    window.clearTimeout(searchDisplayObserverTimer);

    searchDisplayObserver = new MutationObserver(scheduleSearchDisplayRestore);
    searchDisplayObserver.observe(document.body, {
      childList: true,
      subtree: true,
    });

    searchDisplayObserverTimer = window.setTimeout(() => {
      if (searchDisplayObserver) searchDisplayObserver.disconnect();
      searchDisplayObserver = undefined;
      restoreSearchDisplayTerm();
    }, 5000);
  };

  document.addEventListener(
    'click',
    (event) => {
      const link = event.target.closest && event.target.closest('a[href]');
      if (!link) return;

      const url = new URL(link.href, window.location.origin);
      const updatesSearchResults =
        url.origin === window.location.origin &&
        url.pathname.endsWith('/search') &&
        url.searchParams.has(displayTermParameter);

      if (updatesSearchResults) observeSearchDisplayUpdates();
    },
    true
  );

  const initializeSearchDisplayTerm = () => {
    restoreSearchDisplayTerm();
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initializeSearchDisplayTerm, {
      once: true,
    });
  } else {
    initializeSearchDisplayTerm();
  }
})();


/* Sibling variant preservation */
(() => {
  const containerSelector = '[data-current-variant-options]';
  const linkSelector = '[data-sibling-base-url][data-sibling-variants]';

  const sameOptions = (first, second) =>
    Array.isArray(first) &&
    Array.isArray(second) &&
    first.length === second.length &&
    first.every((value, index) => String(value) === String(second[index]));

  const parseJson = (value, fallback = []) => {
    try {
      return JSON.parse(value || '');
    } catch (error) {
      return fallback;
    }
  };

  const updateLink = (link, selectedOptions) => {
    const baseUrl = link.dataset.siblingBaseUrl;
    const variants = parseJson(link.dataset.siblingVariants);
    const matchingVariant = variants.find((variant) =>
      sameOptions(variant.options, selectedOptions)
    );

    if (!baseUrl) return;

    if (!matchingVariant) {
      link.setAttribute('href', baseUrl);
      return;
    }

    const variantUrl = new URL(baseUrl, window.location.origin);
    variantUrl.searchParams.set('variant', matchingVariant.id);
    link.setAttribute(
      'href',
      `${variantUrl.pathname}${variantUrl.search}${variantUrl.hash}`
    );
  };

  const updateContainer = (container, selectedOptions) => {
    container
      .querySelectorAll(linkSelector)
      .forEach((link) => updateLink(link, selectedOptions));
  };

  const initialize = (root = document) => {
    root.querySelectorAll(containerSelector).forEach((container) => {
      const selectedOptions = parseJson(
        container.dataset.currentVariantOptions
      );
      updateContainer(container, selectedOptions);
    });
  };

  const initializePage = () => initialize(document);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initializePage, {
      once: true,
    });
  } else {
    initializePage();
  }

  document.addEventListener('shopify:section:load', (event) => {
    initialize(event.target);
  });

  document.addEventListener('theme:variant:change', (event) => {
    const selectedOptions = event.detail?.variant?.options;
    if (!Array.isArray(selectedOptions)) return;

    const target = event.target;
    const scope =
      target instanceof Element
        ? target.closest('product-component, quick-add-product, [data-product]')
        : null;

    (scope || document)
      .querySelectorAll(containerSelector)
      .forEach((container) => {
        container.dataset.currentVariantOptions =
          JSON.stringify(selectedOptions);
        updateContainer(container, selectedOptions);
      });
  });
})();

(() => {
  const COMPANY_ID = 'Yi4egK';
  const SCRIPT_URL = `https://static.klaviyo.com/onsite/js/${COMPANY_ID}/klaviyo.js?company_id=${COMPANY_ID}`;
  const FIRST_TOUCH_KEY = 'le_klaviyo_first_touch_v1';
  const FIRST_TOUCH_EVENT = 'LE First Touch Candidate';
  const PAGE_VIEW_EVENT = 'LE Viewed Page';
  const API_WAIT_ATTEMPTS = 80;
  const API_WAIT_DELAY = 100;
  const LOAD_RETRY_ATTEMPTS = 3;
  let loadPromise = null;
  let privacyPromise = null;
  let viewedProductState = 'idle';
  let pageViewState = 'idle';
  let trackingActive = false;

  const limit = (value, length = 500) => String(value || '').slice(0, length);

  const cleanUrl = (value) => {
    if (!value) return '';

    try {
      const url = new URL(value, window.location.origin);
      return `${url.origin}${url.pathname}`;
    } catch (error) {
      return '';
    }
  };

  const queryValue = (name) => {
    const match = Array.from(new URLSearchParams(window.location.search).entries()).find(
      ([key]) => key.toLowerCase() === name
    );

    return limit(match?.[1] || '', 255);
  };

  const referrerHostname = () => {
    if (!document.referrer) return '';

    try {
      return new URL(document.referrer).hostname.toLowerCase().replace(/^www\./, '');
    } catch (error) {
      return '';
    }
  };

  const inferredAttribution = () => {
    const utmSource = queryValue('utm_source');
    const utmMedium = queryValue('utm_medium');
    const hostname = referrerHostname();

    if (utmSource) {
      return {
        source: utmSource,
        medium: utmMedium || 'campaign'
      };
    }

    if (queryValue('gclid')) return { source: 'google', medium: 'cpc' };
    if (queryValue('fbclid')) return { source: 'meta', medium: 'paid_social' };
    if (!hostname) return { source: 'direct', medium: 'none' };

    if (/(^|\.)google\.|(^|\.)bing\.com$|(^|\.)duckduckgo\.com$/.test(hostname)) {
      return {
        source: hostname.split('.').find((part) => ['google', 'bing', 'duckduckgo'].includes(part)) || hostname,
        medium: 'organic'
      };
    }

    if (/(^|\.)(chatgpt\.com|openai\.com)$/.test(hostname)) {
      return { source: 'chatgpt', medium: 'referral' };
    }

    if (/(^|\.)(facebook\.com|instagram\.com|fb\.com)$/.test(hostname)) {
      return { source: 'meta', medium: 'social' };
    }

    return { source: hostname, medium: 'referral' };
  };

  const pageAttribution = inferredAttribution();

  const pageFirstTouch = {
    landing_page: cleanUrl(window.location.href),
    referrer: cleanUrl(document.referrer),
    source: pageAttribution.source,
    medium: pageAttribution.medium,
    utm_source: queryValue('utm_source'),
    utm_medium: queryValue('utm_medium'),
    utm_campaign: queryValue('utm_campaign'),
    utm_id: queryValue('utm_id'),
    utm_content: queryValue('utm_content'),
    utm_term: queryValue('utm_term'),
    gclid: queryValue('gclid'),
    fbclid: queryValue('fbclid'),
    captured_at: new Date().toISOString()
  };

  const storageRead = () => {
    try {
      const value = localStorage.getItem(FIRST_TOUCH_KEY);
      return value ? JSON.parse(value) : null;
    } catch (error) {
      return null;
    }
  };

  const storageWrite = (value) => {
    try {
      localStorage.setItem(FIRST_TOUCH_KEY, JSON.stringify(value));
    } catch (error) {
      return false;
    }

    return true;
  };

  const storageRemove = () => {
    try {
      localStorage.removeItem(FIRST_TOUCH_KEY);
    } catch (error) {
      return false;
    }

    return true;
  };

  const getPrivacyApi = () =>
    window.Shopify?.customerPrivacy || window.Shopify?.trackingConsent || null;

  const canTrack = () => {
    const privacy = getPrivacyApi();

    if (!privacy) return false;

    try {
      const analyticsAllowed = privacy.analyticsProcessingAllowed?.call(privacy);
      const marketingAllowed =
        privacy.marketingAllowed?.call(privacy) ??
        privacy.firstPartyMarketingAllowed?.call(privacy);

      return Boolean(
        analyticsAllowed && marketingAllowed
      );
    } catch (error) {
      return false;
    }
  };

  const ensurePrivacyApi = () => {
    if (getPrivacyApi()) return Promise.resolve(getPrivacyApi());
    if (privacyPromise) return privacyPromise;

    privacyPromise = new Promise((resolve) => {
      let attempts = 0;
      let requested = false;

      const check = () => {
        const privacy = getPrivacyApi();

        if (privacy) {
          resolve(privacy);
          return;
        }

        const loader = window.Shopify?.loadFeatures;

        if (!requested && typeof loader === 'function') {
          requested = true;
          loader(
            [{ name: 'consent-tracking-api', version: '0.1' }],
            (error) => {
              if (error) {
                resolve(null);
                return;
              }

              check();
            }
          );
          return;
        }

        attempts += 1;

        if (attempts >= API_WAIT_ATTEMPTS) {
          resolve(null);
          return;
        }

        window.setTimeout(check, API_WAIT_DELAY);
      };

      check();
    });

    return privacyPromise;
  };

  const firstTouchProperties = () => {
    if (!canTrack()) return {};

    let firstTouch = storageRead();

    if (!firstTouch) {
      firstTouch = pageFirstTouch;
      storageWrite(firstTouch);
    }

    const properties = {
      'LE First Touch Landing Page': limit(firstTouch.landing_page),
      'LE First Touch Captured At': limit(firstTouch.captured_at, 50)
    };

    const optionalProperties = {
      'LE First Touch Referrer': firstTouch.referrer,
      'LE First Touch Source': firstTouch.source,
      'LE First Touch Medium': firstTouch.medium,
      'LE First Touch UTM Source': firstTouch.utm_source,
      'LE First Touch UTM Medium': firstTouch.utm_medium,
      'LE First Touch UTM Campaign': firstTouch.utm_campaign,
      'LE First Touch UTM ID': firstTouch.utm_id,
      'LE First Touch UTM Content': firstTouch.utm_content,
      'LE First Touch UTM Term': firstTouch.utm_term,
      'LE First Touch GCLID': firstTouch.gclid,
      'LE First Touch FBCLID': firstTouch.fbclid
    };

    Object.entries(optionalProperties).forEach(([key, value]) => {
      if (value) properties[key] = limit(value);
    });

    return properties;
  };

  const waitForKlaviyoApi = (resolve, reject, attempt = 0) => {
    const api = window.klaviyo;

    if (
      api &&
      typeof api.track === 'function' &&
      typeof api.identify === 'function'
    ) {
      // Never resolve a Promise with Klaviyo's queue/proxy itself: Promise
      // resolution probes a `then` property and Klaviyo treats that as a
      // queued command. Resolve with a plain boolean instead.
      resolve(true);
      return;
    }

    if (attempt >= API_WAIT_ATTEMPTS) {
      reject(new Error('Klaviyo JavaScript API did not become ready'));
      return;
    }

    window.setTimeout(
      () => waitForKlaviyoApi(resolve, reject, attempt + 1),
      API_WAIT_DELAY
    );
  };

  const loadKlaviyo = () => {
    if (!canTrack()) return Promise.resolve(null);
    if (loadPromise) return loadPromise;

    let loaderScript = null;

    loadPromise = new Promise((resolve, reject) => {
      const ready = () => waitForKlaviyoApi(resolve, reject);
      const fail = (error) => {
        const script = loaderScript;

        if (script?.dataset.leKlaviyoLoader === 'true') {
          script.dataset.leKlaviyoFailed = 'true';
          script.remove();
        }

        reject(error);
      };
      const existingScript = Array.from(document.scripts).find(
        (script) =>
          script.src.includes(`/onsite/js/${COMPANY_ID}/klaviyo.js`) &&
          script.dataset.leKlaviyoFailed !== 'true'
      );

      if (existingScript) {
        loaderScript = existingScript;
        existingScript.addEventListener('load', ready, { once: true });
        existingScript.addEventListener(
          'error',
          () => fail(new Error('Klaviyo script failed to load')),
          { once: true }
        );
        ready();
        return;
      }

      const script = document.createElement('script');
      script.async = true;
      script.src = SCRIPT_URL;
      script.dataset.leKlaviyoLoader = 'true';
      loaderScript = script;
      script.addEventListener('load', ready, { once: true });
      script.addEventListener(
        'error',
        () => fail(new Error('Klaviyo script failed to load')),
        { once: true }
      );
      document.head.appendChild(script);
    }).catch((error) => {
      if (loaderScript?.dataset.leKlaviyoLoader === 'true') {
        loaderScript.dataset.leKlaviyoFailed = 'true';
        loaderScript.remove();
      }
      loadPromise = null;
      throw error;
    });

    return loadPromise;
  };

  const productData = () => {
    const element = document.getElementById('le-klaviyo-product-data');

    if (!element) return null;

    try {
      return JSON.parse(element.textContent);
    } catch (error) {
      console.error('Invalid Klaviyo product data', error);
      return null;
    }
  };

  const trackViewedProduct = (api) => {
    const payload = productData();

    if (!payload || viewedProductState !== 'idle' || !canTrack()) return;

    viewedProductState = 'pending';

    try {
      // Klaviyo's browser API may return its queue/proxy. Awaiting that value
      // makes JavaScript probe a synthetic `then` method, which Klaviyo then
      // misinterprets as an event command.
      api.track('Viewed Product', payload);
      viewedProductState = 'sent';
    } catch (error) {
      viewedProductState = 'idle';
      throw error;
    }
  };

  const trackPageView = (api) => {
    if (pageViewState !== 'idle' || !canTrack()) return;

    pageViewState = 'pending';

    try {
      api.track(PAGE_VIEW_EVENT, {
        'Page URL': limit(window.location.href, 1000),
        'Page Path': limit(window.location.pathname, 500),
        'Page Title': limit(document.title, 500),
        Referrer: cleanUrl(document.referrer),
        Source: pageAttribution.source,
        Medium: pageAttribution.medium
      });
      pageViewState = 'sent';
    } catch (error) {
      pageViewState = 'idle';
      throw error;
    }
  };

  const activate = async (attempt = 0) => {
    if (!canTrack()) return false;

    firstTouchProperties();

    try {
      const loaded = await loadKlaviyo();
      const api = window.klaviyo;

      if (!loaded || !api || !canTrack()) return false;

      trackPageView(api);
      trackViewedProduct(api);
      trackingActive = true;
      return true;
    } catch (error) {
      if (attempt + 1 < LOAD_RETRY_ATTEMPTS && canTrack()) {
        await new Promise((resolve) =>
          window.setTimeout(resolve, API_WAIT_DELAY * 2 ** attempt)
        );
        return activate(attempt + 1);
      }

      console.error('Klaviyo activation failed', error);
      return false;
    }
  };

  const identify = async (email, properties = {}, attempt = 0) => {
    if (!email || !canTrack()) return false;

    try {
      const loaded = await loadKlaviyo();
      const api = window.klaviyo;

      if (!loaded || !api || !canTrack()) return false;

      const firstTouch = firstTouchProperties();

      // The profile fields make attribution visible directly on the profile.
      // The companion event below remains the immutable audit trail if the
      // same profile is later identified from a different browser.
      // Do not await the browser queue/proxy returned by Klaviyo (see above).
      api.identify({
        email,
        ...properties,
        ...firstTouch
      });

      if (firstTouch['LE First Touch Landing Page']) {
        api.track(FIRST_TOUCH_EVENT, firstTouch);
      }

      trackingActive = true;
      return true;
    } catch (error) {
      if (attempt + 1 < LOAD_RETRY_ATTEMPTS && canTrack()) {
        await new Promise((resolve) =>
          window.setTimeout(resolve, API_WAIT_DELAY * 2 ** attempt)
        );
        return identify(email, properties, attempt + 1);
      }

      throw error;
    }
  };

  window.LisaEleniKlaviyo = {
    activate,
    canTrack,
    firstTouchProperties,
    identify,
    load: loadKlaviyo
  };

  const refreshConsent = () => {
    if (!canTrack()) {
      storageRemove();

      if (trackingActive) window.location.reload();
      return;
    }

    activate();
    window.setTimeout(activate, 250);
  };

  document.addEventListener('visitorConsentCollected', refreshConsent);
  window.addEventListener('PandectesEvent_OnConsent', refreshConsent);
  ensurePrivacyApi().then(activate);
})();
(() => {
  const hydrate = (image) => {
    if (image.dataset.deferredLoaded === 'true') return;
    image.dataset.deferredLoaded = 'true';
    image.classList.add('is-loading');

    const wrapper = image.closest('[data-deferred-image-wrapper]');
    wrapper?.classList.add('is-loading');

    image.addEventListener(
      'load',
      () => {
        image.classList.remove('is-loading');
        wrapper?.classList.remove('is-loading');
      },
      { once: true }
    );

    if (image.dataset.srcset) image.srcset = image.dataset.srcset;
    if (image.dataset.sizes) image.sizes = image.dataset.sizes;
    image.src = image.dataset.src;
  };

  const initialize = (scope = document) => {
    const images = scope.querySelectorAll('[data-deferred-image]:not([data-deferred-loaded="true"])');
    if (!images.length) return;

    if (!('IntersectionObserver' in window)) {
      images.forEach(hydrate);
      return;
    }

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (!entry.isIntersecting) return;
          observer.unobserve(entry.target);
          hydrate(entry.target);
        });
      },
      { rootMargin: '700px 600px' }
    );

    images.forEach((image) => observer.observe(image));
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initialize(), { once: true });
  } else {
    initialize();
  }

  document.addEventListener('shopify:section:load', (event) => initialize(event.target));
})();


/* Variant-specific piercing-position badges */
(() => {
  const guideSelector = '[data-cro-test="fit-guide"]';
  const mapSelector = '[data-cro-fit-map]';
  const positionsSelector = '[data-cro-fit-positions]';

  const cleanPositions = (value) =>
    Array.isArray(value)
      ? value
          .filter((position) => typeof position === 'string' && position.trim())
          .map((position) => position.trim())
      : [];

  const updateGuide = (guide, variantId) => {
    const mapNode = guide.querySelector(mapSelector);
    const list = guide.querySelector(positionsSelector);
    if (!mapNode || !list || !variantId) return;

    let data;
    try {
      data = JSON.parse(mapNode.textContent);
    } catch (error) {
      return;
    }

    const variantPositions = cleanPositions(
      data?.variants?.[String(variantId)]
    );
    const fallbackPositions = cleanPositions(data?.fallback);
    const positions = variantPositions.length
      ? variantPositions
      : fallbackPositions;

    list.replaceChildren(
      ...positions.map((position) => {
        const item = document.createElement('li');
        item.textContent = position;
        return item;
      })
    );
    guide.hidden = positions.length === 0;
  };

  document.addEventListener('theme:variant:change', (event) => {
    const variantId = event.detail?.variant?.id;
    if (!variantId) return;

    const target = event.target;
    const scope =
      target instanceof Element
        ? target.closest('product-component, quick-add-product, [data-product]')
        : null;

    (scope || document)
      .querySelectorAll(guideSelector)
      .forEach((guide) => updateGuide(guide, variantId));
  });
})();
